import { gql } from '@apollo/client';

export const UPDATE_SMART_CODES_MUTATION = gql`
  mutation updateSmartCodes($smartCodes: [SmartCodeUpdateInputType]!) {
    smartCode {
      updateSmartCodes: bulkUpdate(smartCodes: $smartCodes)
    }
  }
`;
